// extracted by mini-css-extract-plugin
export var cardTitle = "_jk-1";
export var commentBubble = "_jk-e";
export var commentForm = "_jk-a";
export var commentInput = "_jk-b";
export var commentLabel = "_jk-d";
export var commentPrompt = "_jk-9";
export var csatCard = "_jk-0";
export var feedbackSection = "_jk-7";
export var starDisabled = "_jk-6";
export var starEmpty = "_jk-5";
export var starFilled = "_jk-4";
export var starWrapper = "_jk-3";
export var starsContainer = "_jk-2";
export var submittedComment = "_jk-c";
export var thankYouText = "_jk-8";